import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import excelIcon from "../../assets/svg/excel-icon.svg";
import pdfIcon from "../../assets/svg/pdf-icon.svg";
import templateIcon from "../../assets/svg/template-icon.svg";
import {
  downloadDashboardExcelApi,
  downloadDashboardExcelPostApi,
} from "../masters/master-api";
import { downloadBase64File } from "../report/report-api";

const ExcelPDFDashboardButtons = ({
  pdfRef,
  activeTab,
  responseMsg,
  downloadPdfRef,
  startDate,
  locationSelectedMonth,
  averageMonthDate,
  dayWiseMonthDate,
  dayWiseAverageMonth,
  statusType,
  selectedVehicleMonth,
  selectedDeptMonth,
  isTemplate,
  isExcel,
  isPdf,
}) => {
  const tabs = [
    {
      excel_download_url: "dashboard/live_count",
      key: "live_count",
    },
    {
      excel_download_url: "dashboard/history",
      key: "history",
    },
    {
      excel_download_url: "dashboard/location_wise",
      key: "location_wise",
    },
    {
      excel_download_url: "dashboard/day_wise",
      key: "day_wise",
    },
    {
      excel_download_url: "dashboard/free_dock",
      key: "free_dock",
    },
    {
      excel_download_url: "dashboard/avg_duration",
      key: "avg_duration",
    },
    {
      excel_download_url: "dashboard/vehicle_timing",
      key: "vehicle_timing",
    },
    {
      excel_download_url: "dashboard/come_in_out",
      key: "come_in_out",
    },
    {
      excel_download_url: "dashboard/status_avg_duration",
      key: "status_avg_duration",
    },
    {
      excel_download_url: "dashboard/department_log",
      key: "department_log",
    },
    {
      excel_download_url: "dashboard/overall_report",
      key: "overall_report",
    },

    {
      excel_download_url: "dashboard/live_moniter",
      key: "live_moniter",
    },
  ];

  const [isDownloading, setIsDownloading] = useState(false);

  const downloadExcelGet = async (responseMsg) => {
    const index = tabs.findIndex((item) => item.key === activeTab);
    if (index > -1) {
      setIsDownloading(true);
      const response = await downloadDashboardExcelApi(
        tabs[index].excel_download_url
      );
      setIsDownloading(false);
      if (response.status === 200) {
        if (response.data.success === true) {
          const base64String = response.data.base64; // Truncated for brevity
          const fileName = response.data.file_name;
          // Convert Base64 to Blob
          downloadBase64File(base64String, fileName);
          responseMsg(response.data);
        } else {
          responseMsg(response.data);
        }
      }
    }
  };
  const downloadExcelPost = async (responseMsg, payload) => {
    const index = tabs.findIndex((item) => item.key === activeTab);
    if (index > -1) {
      setIsDownloading(true);
      const response = await downloadDashboardExcelPostApi(
        tabs[index].excel_download_url,
        payload
      );
      setIsDownloading(false);
      if (response.status === 200) {
        if (response.data.success === true) {
          const base64String = response.data.base64; // Truncated for brevity
          const fileName = response.data.file_name;
          // Convert Base64 to Blob
          downloadBase64File(base64String, fileName);
          responseMsg(response.data);
        } else {
          responseMsg(response.data);
        }
      }
    }
  };

  return (
    <div className="ms-2 no-print">
      {tabs.findIndex((item) => item.key === activeTab) > -1 && (
        <div className="style-justify-start">
          {isExcel && (
            <>
              <button
                className="me-2"
                onClick={
                  isDownloading === false
                    ? () => {
                        if (
                          activeTab === "live_count" ||
                          activeTab === "live_moniter"
                        ) {
                          downloadExcelGet(responseMsg);
                        }
                        if (
                          activeTab === "history" ||
                          activeTab === "free_dock" ||
                          activeTab === "vehicle_timing"
                        ) {
                          downloadExcelPost(responseMsg, {
                            start_date: startDate,
                          });
                        }
                        if (activeTab === "location_wise") {
                          downloadExcelPost(responseMsg, {
                            period: locationSelectedMonth,
                          });
                        }
                        if (activeTab === "avg_duration") {
                          downloadExcelPost(responseMsg, {
                            period: averageMonthDate,
                          });
                        }

                        if (activeTab === "day_wise") {
                          downloadExcelPost(responseMsg, {
                            period: dayWiseMonthDate,
                          });
                        }
                        if (activeTab === "status_avg_duration") {
                          downloadExcelPost(responseMsg, {
                            period: dayWiseAverageMonth,
                            type: statusType,
                          });
                        }
                        if (activeTab === "come_in_out") {
                          downloadExcelPost(responseMsg, {
                            period: selectedVehicleMonth,
                          });
                        }
                        if (activeTab === "department_log") {
                          downloadExcelPost(responseMsg, {
                            period: selectedDeptMonth,
                          });
                        }
                        if (activeTab === "overall_report") {
                          downloadExcelPost(responseMsg, {
                            start_date: startDate,
                            period: dayWiseAverageMonth,
                            type: statusType,

                            inout_period: selectedVehicleMonth,

                            dept_period: selectedDeptMonth,
                          });
                        }
                      }
                    : null
                }
                style={{
                  background: "none",
                  border: "0.6px solid #DCDFE4",
                  borderRadius: "12px",
                  padding: "8px 8px",
                  /* height: "32px", */
                  /* width: "40px", */
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  opacity: isDownloading ? 0.6 : 1,
                }}
              >
                <img
                  src={excelIcon}
                  alt="excel"
                  style={{ width: "14px", height: "14px" }}
                />
              </button>
            </>
          )}
          {isPdf && (
            <button
              onClick={() => {
                downloadPdfRef(pdfRef, activeTab);
              }}
              className="me-2"
              style={{
                background: "none",
                border: "0.6px solid #DCDFE4",
                borderRadius: "12px",
                padding: "8px 8px",
                /* height: "32px", */
                /* width: "40px", */
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                opacity: isDownloading ? 0.6 : 1,
              }}
            >
              <img
                src={pdfIcon}
                alt="pdf"
                style={{ width: "14px", height: "14px" }}
              />
            </button>
          )}
        </div>
      )}
      {/* {tabs.map(({ label, to, key }) => (
                <Link
                    key={key}
                    to={to}
                    className={`customer-tab ${activeTab === key ? "active" : ""}`}
                    onClick={() => setActiveTab(key)}
                >
                    {label}
                </Link>
            ))} */}
    </div>
  );
};

export default ExcelPDFDashboardButtons;
